import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrder, IOrderInput } from "@/interfaces/order.interfaces";
import orderService from "@/services/order.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateOrderProps = {
  formData: IOrderInput;
} & RequestsProps;

export type UseCreateOrderReturn = {
  create: (props: CreateOrderProps) => Promise<IOrder>;
} & UseLoadingReturn;

const useCreateOrder = (): UseCreateOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderInput>({
    operation: (formData) => orderService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateOrder;
